import React from 'react';
const TickDynamica = () => {
  return (
    <svg className='vTick' width='33' height='33' viewBox='0 0 110 130' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M37.5 57.267 55.337 75 83.5 47' stroke='#000' stroke-width='10' stroke-linecap='square'></path>
    </svg>
  );
};

export default TickDynamica;
